import {
    Component,
    OnDestroy,
    OnInit,
    HostBinding,
    HostListener,
    ViewEncapsulation,
} from "@angular/core";
import {MediaObserver} from "@angular/flex-layout";

import * as _ from "lodash";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";

import {AuthenticationService} from "app/auth/service";
import {CoreSidebarService} from "@core/components/core-sidebar/core-sidebar.service";
import {CoreConfigService} from "@core/services/config.service";
import {CoreMediaService} from "@core/services/media.service";

import {User} from "app/auth/models";

import {coreConfig} from "app/app-config";
import {Router} from "@angular/router";
import {EmpresaService, SociosService} from "app/main/_services";
import {Socios} from "app/main/_model/socios/socios";
import {Subscription, interval} from "rxjs";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit, OnDestroy {
    private subscription: Subscription;
    public dateNow = new Date();
    public dDay = new Date("Jan 22 2021 00:00:00");
    public timeDifference;
    public logo: any;
    public avatar: any;
    public socio: Socios;
    public horizontalMenu: boolean;
    public hiddenMenu: boolean;

    public coreConfig: any;
    //public config = coreConfig.app;
    public currentSkin: string;
    public prevSkin: string;

    public currentUser: User;

    public languageOptions: any;
    public navigation: any;
    public selectedLanguage: any;

    public logoBase64: any;

    @HostBinding("class.fixed-top")
    public isFixed = false;

    @HostBinding("class.navbar-static-style-on-scroll")
    public windowScrolled = false;

    // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
    @HostListener("window:scroll", [])
    onWindowScroll() {
        if (
            (window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop > 100) &&
            this.coreConfig.layout.navbar.type == "navbar-static-top"
        ) {
            this.windowScrolled = true;
        } else if (
            (this.windowScrolled && window.pageYOffset) ||
            document.documentElement.scrollTop ||
            document.body.scrollTop < 10
        ) {
            this.windowScrolled = false;
        }
    }

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     * @param {AuthenticationService} _authenticationService
     * @param {CoreConfigService} _coreConfigService
     * @param {CoreSidebarService} _coreSidebarService
     * @param {CoreMediaService} _coreMediaService
     * @param {MediaObserver} _mediaObserver
     * @param {TranslateService} _translateService
     */
    public activeLang = "es";

    constructor(
        private _router: Router,
        private _authenticationService: AuthenticationService,
        private _coreConfigService: CoreConfigService,
        private _coreMediaService: CoreMediaService,
        private _coreSidebarService: CoreSidebarService,
        private _mediaObserver: MediaObserver,
        public _translateService: TranslateService,
        private _empresaService: EmpresaService,
        private _sociosService: SociosService
    ) {
        this._authenticationService.currentUser.subscribe(
            (x) => (this.currentUser = x)
        );
        this._empresaService.getlogoComprimido.subscribe(res => this.logoBase64 = res);
        this.languageOptions = {
            es: {
                title: "Español",
                flag: "es",
            },
            en: {
                title: "English",
                flag: "us",
            },
            fr: {
                title: "French",
                flag: "fr",
            },
            de: {
                title: "German",
                flag: "de",
            },
            pt: {
                title: "Portuguese",
                flag: "pt",
            },
        };

        //  this._translateService.setDefaultLang(this.activeLang);
        // console.log(this._translateService)
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // Public Methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebar(key): void {
        this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
    }

    /**
     * Set the language
     *
     * @param language
     */
    setLanguage(language): void {
        // console.log(language)
        // Set the selected language for the navbar on change
        this.selectedLanguage = language;

        // Use the selected language id for translations
        this._translateService.use(language);
        //console.log(this._translateService)
    }

    /**
     * Toggle Dark Skin
     */
    toggleDarkSkin() {
        // Get the current skin
        this._coreConfigService
            .getConfig()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.currentSkin = config.layout.skin;
            });

        // Toggle Dark skin with prevSkin skin
        this.prevSkin = localStorage.getItem("prevSkin");

        if (this.currentSkin === "dark") {
            this._coreConfigService.setConfig(
                {layout: {skin: this.prevSkin ? this.prevSkin : "default"}},
                {emitEvent: true}
            );
        } else {
            localStorage.setItem("prevSkin", this.currentSkin);
            this._coreConfigService.setConfig(
                {layout: {skin: "dark"}},
                {emitEvent: true}
            );
        }
    }

    /**
     * Logout method
     */
    logout() {
        this._authenticationService.logout();
        //this.subscription.unsubscribe();
        // this._router.navigate(['/pages/authentication/login-v2']);
        this._router.navigate(["/auth/login"]);
    }

    // Lifecycle Hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._empresaService.generarLogobase64();
        // get the currentUser details from localStorage
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser === null) {
            this.logout();
        }else{
            this._sociosService
                .getSocio(this.currentUser.list)
                .then((res) => {
                    if (res === null) {
                        this.logout();
                    } else {
                        this.caducarInactividad(this.currentUser.dataset.caducidad);
                        this.socio = res;
                        if (this.currentUser.dataset.avatar === "M") {
                            this.avatar = "avatar-s-11.jpg";
                        } else if (this.currentUser.dataset.avatar === "F") {
                            this.avatar = "avatar-s-2.jpg";
                        } else {
                            this.avatar = "avatar-s-2.jpg";
                        }
                    }
                })
                .catch(() => {
                    this.logout();
                });
        }



        /**/

        // Subscribe to the config changes
        this._coreConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.coreConfig = config;
                //console.log(this.coreConfig)
                this.horizontalMenu = config.layout.type === "horizontal";
                this.hiddenMenu = config.layout.menu.hidden === true;
                this.currentSkin = config.layout.skin;

                // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
                if (this.coreConfig.layout.type === "vertical") {
                    setTimeout(() => {
                        if (this.coreConfig.layout.navbar.type === "fixed-top") {
                            this.isFixed = true;
                        }
                    }, 0);
                }
            });

        // Horizontal Layout Only: Add class fixed-top to navbar below large screen
        if (this.coreConfig.layout.type == "horizontal") {
            // On every media(screen) change
            this._coreMediaService.onMediaUpdate
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {
                    const isFixedTop = this._mediaObserver.isActive("bs-gt-xl");
                    if (isFixedTop) {
                        this.isFixed = false;
                    } else {
                        this.isFixed = true;
                    }
                });
        }

        // Set the selected language from default languageOptions
        this.selectedLanguage = _.find(this.languageOptions, {
            id: this._translateService.currentLang,
        });
        //cargar logo
        if (this.currentUser !== null) {
            this._empresaService.getLogo().subscribe((res) => {
                this.logo = res;
            });
        }

    }

    private caducarInactividad(fecha) {
        const caducidad = new Date(fecha).getTime();
        this.subscription = interval(1000).subscribe((x) => {
            var now = new Date().getTime();
            var timeleft = caducidad - now;
           if (timeleft < 0) {
                clearInterval();
                this.logout();
                this.subscription.unsubscribe();
           }
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        //this.subscription.unsubscribe();
    }
}
